import type { FC } from 'react';
import StopSelectionPopupContent from '../shared/StopSelectionPopupContent';
import { MapPointKind } from './MapPointKind';
import { colorOrigin, colorTarget } from './TripPLannerUtils';

interface TripPlannerPointPopupContentProps {
    kind: MapPointKind;
    onSelectFrom: () => void;
    onSelectTo: () => void;
}

const statusStyle = {
    marginTop: 4,
    fontSize: 12,
    fontWeight: 600,
} as const;

const TripPlannerPointPopupContent: FC<TripPlannerPointPopupContentProps> = ({
    kind,
    onSelectFrom,
    onSelectTo,
}) => {
    if (kind === MapPointKind.unknown) {
        return (
            <StopSelectionPopupContent
                onSelectFrom={onSelectFrom}
                onSelectTo={onSelectTo}
            />
        );
    }

    return (
        <div
            style={{
                ...statusStyle,
                color: kind === MapPointKind.from ? colorOrigin : colorTarget,
            }}
        >
            {kind === MapPointKind.from ? 'From' : 'To'}
        </div>
    );
};

export default TripPlannerPointPopupContent;
